<!-- 收款台操作 -->
<template>
   <div class="store-modal-content">
      <div class="data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
               :tabslist="formDataList" @tabs="
                  (val) => {
                     showTabs = val
                  }
               ">
               <template slot="tabs" slot-scope="scope">
                  <div class="table_content_box">
                     <!-- 主信息 -->
                     <div v-if="scope.index == 0" class="main-layout">
                        <!-- 左侧区域：表单 + 单品特价设置 -->
                        <div class="left-section">
                           <!-- 表单区域 -->
                           <div class="form-section">
                              <el-form size="mini" :model="sendDataInfo" label-width="120px" ref="sendDataInfo"
                                 :show-message="false" :inline-message="false" class="promotion-form">

                                 <!-- 基本信息 -->
                                 <div class="form-group">
                                    <div class="group-title">基本信息   <el-button type="primary" size="mini" @click="openSchemeDialog"
                                             :disabled="dataActionBox.actionType == 2">
                                             <i class="el-icon-folder-opened"></i> 选择已有方案
                                          </el-button>    </div>
                                    <div class="form-row">
                                       <el-form-item label="方案名称" prop="planName" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input v-model.trim="sendDataInfo.planName"
                                             :maxlength="$store.state.inputLength" placeholder="填写方案名称"
                                             style="width: 100%;"></el-input>
                                       </el-form-item>
                                 
                                       <el-form-item label="会员要求" prop="memReq" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-select v-model.number="sendDataInfo.memReq" placeholder="选择会员要求"
                                             @change="handleMemberTypeChange" style="width: 100%;">
                                             <el-option label="不限" :value=1></el-option>
                                             <el-option label="会员卡类型" :value=2></el-option>
                                             <!-- <el-option label="会员积分" :value=3></el-option> -->
                                          </el-select>
                                       </el-form-item>
                                       <!-- <el-form-item v-if="sendDataInfo.memReq === 3" label="积分要求" prop="memReqPoint"
                                          class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input v-model.number="sendDataInfo.memReqPoint" type="number" :min="0"
                                             placeholder="请输入积分要求"></el-input>
                                       </el-form-item> -->

                          
                               
                                    </div>
                                    <div v-if="sendDataInfo.memReq === 2" style="width: 100%;" class="form-row">
                                       <el-form-item label="选择会员卡类型" prop="selectedCardTypeIds"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]"
                                          class="form-item-full">
                                          <div class="card-type-selection">
                                             <div class="selection-header">
                                                <span class="selection-title">已选择 {{ selectedCardTypes.length }}/{{
                                                   cardTypeList.length }} 个会员卡类型</span>
                                             </div>
                                             <el-table 
                                                :data="cardTypeList" 
                                                size="mini" 
                                                height="180"
                                                @selection-change="handleCardTypeSelectionChange"
                                                ref="cardTypeTable"
                                                border>
                                                <el-table-column 
                                                   type="selection" 
                                                   width="55" 
                                                   align="center"
                                                   :selectable="() => true">
                                                </el-table-column>
                                                <el-table-column 
                                                   prop="capCode" 
                                                   label="卡类型编号" 
                                                   width="120" 
                                                   align="center">
                                                </el-table-column>
                                                <el-table-column 
                                                   prop="capName" 
                                                   label="卡类型名称" 
                                                   min-width="150" 
                                                   align="center">
                                                </el-table-column>
                                                <!-- <el-table-column 
                                                   label="扣率" 
                                                   width="100" 
                                                   align="center">
                                                   <template slot-scope="scope">
                                                      <span v-if="scope.row.isDiscont" class="card-discount">
                                                         {{ (scope.row.discount * 10).toFixed(0) }}折
                                                      </span>
                                                      <span v-else class="card-no-discount">无折扣</span>
                                                   </template>
                                                </el-table-column> -->
                                             </el-table>
                                          </div>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="变价规则" prop="clType" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-select v-model.number="sendDataInfo.clType" placeholder="选择变价规则"
                                             @change="handleClTypeChange" style="width: 100%;">
                                             <el-option label="达到数量整体变价" :value=1></el-option>
                                             <el-option label="按数量递增变价" :value=2></el-option>
                                          </el-select>
                                       </el-form-item>
                                       <el-form-item label="是否循环促销" prop="clRoundType" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-select v-model.number="sendDataInfo.clRoundType" placeholder="选择是否循环促销"
                                             @change="handleClRoundType" :disabled="sendDataInfo.clType === 1"
                                             style="width: 100%;">
                                             <el-option label="仅促销一次" :value=1></el-option>
                                             <el-option label="循环促销条件" :value=2
                                                :disabled="sendDataInfo.clType === 1"></el-option>
                                             <el-option label="按最后一个优惠处理" :value=3
                                                :disabled="sendDataInfo.clType === 1"></el-option>
                                          </el-select>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="方案描述" prop="planDesc" class="form-item-full"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-input type="textarea" v-model.trim="sendDataInfo.planDesc"
                                             :maxlength="$store.state.inputLength" :rows="3"
                                             placeholder="请输入方案描述"></el-input>
                                       </el-form-item>
                                       <el-form-item label="备注" class="form-item-full">
                                          <el-input type="textarea" v-model="sendDataInfo.remark" :rows="3"
                                             placeholder="请输入备注信息（选填）"></el-input>
                                       </el-form-item>
                                    </div>
                                 </div>
                                 <!-- 时间设置 -->
                                 <div class="form-group">
                                    <div class="group-title">时间设置</div>
                                    <div class="form-row">
                                       <el-form-item label="开始日期" prop="startDate" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-date-picker v-model="sendDataInfo.startDate" type="date"
                                             placeholder="选择开始日期" value-format="timestamp" style="width: 100%;">
                                          </el-date-picker>
                                       </el-form-item>
                                       <el-form-item label="结束日期" prop="endDate" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-date-picker v-model="sendDataInfo.endDate" type="date"
                                             placeholder="选择结束日期" value-format="timestamp" style="width: 100%;">
                                          </el-date-picker>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="开始时间" prop="dayStartTime" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-time-picker v-model="sendDataInfo.dayStartTime" placeholder="选择开始时间"
                                             value-format="HH:mm:ss" style="width: 100%;">
                                          </el-time-picker>
                                       </el-form-item>
                                       <el-form-item label="结束时间" prop="dayEndTime" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <el-time-picker v-model="sendDataInfo.dayEndTime" placeholder="选择结束时间"
                                             value-format="HH:mm:ss" style="width: 100%;">
                                          </el-time-picker>
                                       </el-form-item>
                                    </div>
                                    <div class="form-row">
                                       <el-form-item label="促销周期" prop="mzWeekDays" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <div @click="openPromotionDialog" style="cursor: pointer;">
                                             <el-input type="textarea" v-model="weekDaysDisplayText" readonly
                                                class="promotion-input" style="pointer-events: none;"
                                                placeholder="点击选择促销周期" :rows="3"></el-input>
                                          </div>
                                       </el-form-item>
                                       <el-form-item label="促销日期" prop="mzMonthDays" class="form-item-half"
                                          :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                          <div @click="openPromotionDialog" style="cursor: pointer;">
                                             <el-input type="textarea" v-model="monthDaysDisplayText" readonly
                                                class="promotion-input" style="pointer-events: none;"
                                                placeholder="点击选择促销日期" :rows="3"></el-input>
                                          </div>
                                       </el-form-item>
                                    </div>
                                 </div>
                              </el-form>
                           </div>

                           <!-- 促销条件块 -->
                           <div class="promotion-condition-section">

                              <div class="condition-title">促销条件</div>


                              <!-- 商品列表设置区域 -->
                              <div class="promotion-container">
                                 <!-- 促销条件设置 -->
                                 <div class="promotion-section condition-section">
                                    <div class="section-header-simple">
                                       <div class="header-left-simple">
                                          <h3>参与商品列表</h3>
                                          <p class="section-desc-simple">
                                             选择能够参与促销活动的商品
                                             <span class="list-count">已添加 {{ sendDataInfo.specialList.length }}
                                                个商品</span>
                                          </p>
                                       </div>
                                       <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                          <el-button type="primary" size="mini" @click="addDetails">
                                             <i class="el-icon-plus"></i> 添加参与商品
                                          </el-button>
                                          <el-button type="primary" size="mini" @click="downloadTemplate()">
                                             <i class="el-icon-plus"></i> 下载模版
                                          </el-button>
                                          <el-button type="primary" size="mini" @click="importDetails()">
                                             <i class="el-icon-plus"></i> 导入
                                          </el-button>
                                          <el-button type="danger" size="mini" @click="deleteDetails()">
                                             <i class="el-icon-delete"></i> 删除商品
                                          </el-button>
                                       </div>
                                    </div>

                                    <div class="section-content">
                                       <!-- 商品列表 -->
                                       <div class="goods-list-container">
                                          <div class="goods-table-wrapper">
                                             <el-table size="mini" ref="mxTableRef" id="mxTable"
                                                :data="sendDataInfo.specialList" @row-click="handleRowClick"
                                                height="400" @row-dblclick="openDateilsBox" 
                                                @selection-change="handleSelectionChange" border>
                                                <el-table-column type="selection" width="55" align="center">
                                                </el-table-column>
                                                <!-- 商品名称 -->
                                                <el-table-column align="center" width="200" label="通用名称">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmName }}</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 商品编码（促销类型为21时显示） -->
                                                <el-table-column align="center" width="120" label="商品编码">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmCode }}</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 规格 -->
                                                <el-table-column align="center" width="150" label="规格">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].spec }}</span>
                                                   </template>
                                                </el-table-column>
                                                <el-table-column align="center" width="120" label="最大进价">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].maxPsprice }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- 统一零售价 -->
                                                <el-table-column align="center" width="120" label="统一零售价">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].retailPrice }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- 优惠方式 -->
                                                <el-table-column align="center" width="120" label="优惠方式">
                                                   <template slot-scope="scope">
                                                      <el-select
                                                         v-model.number="sendDataInfo.specialList[scope.$index].clType"
                                                         placeholder="请选择优惠方式"
                                                         @change="handleClTypeChangeInList(scope.$index, sendDataInfo.specialList[scope.$index].clType)">
                                                         <el-option label="按价格促销" :value="1"></el-option>
                                                         <el-option label="按折扣促销" :value="2"></el-option>
                                                      </el-select>
                                                   </template>
                                                </el-table-column>
                                                <!-- 数量要求 -->
                                                <el-table-column align="center" width="120" label="数量要求">
                                                   <template slot-scope="scope">
                                                      <div v-if="sendDataInfo.specialList[scope.$index].clType === 1">
                                                         <!-- 按价格促销 - 显示与价格要求对应的数量要求 -->
                                                         <div
                                                            v-for="(price, priceIndex) in getPriceConditions(scope.$index)"
                                                            :key="'num-price-' + priceIndex"
                                                            class="price-condition-item">
                                                            <el-input
                                                               v-model.number="sendDataInfo.specialList[scope.$index].priceConditions[priceIndex].num"
                                                               placeholder="数量" class="num-input">
                                                            </el-input>
                                                         </div>
                                                      </div>
                                                      <div
                                                         v-else-if="sendDataInfo.specialList[scope.$index].clType === 2">
                                                         <!-- 按折扣促销 - 显示与折扣要求对应的数量要求 -->
                                                         <div
                                                            v-for="(discount, discountIndex) in getDiscountConditions(scope.$index)"
                                                            :key="'num-discount-' + discountIndex"
                                                            class="discount-condition-item">
                                                            <el-input
                                                               v-model.number="sendDataInfo.specialList[scope.$index].discountConditions[discountIndex].num"
                                                               placeholder="数量" class="num-input">
                                                            </el-input>
                                                         </div>
                                                      </div>
                                                      <div v-else>
                                                         <el-input
                                                            v-model.number="sendDataInfo.specialList[scope.$index].num"
                                                            placeholder="请输入数量">
                                                         </el-input>
                                                      </div>
                                                   </template>
                                                </el-table-column>

                                                <!-- 价格要求 - 仅当优惠方式为按价格促销时显示 -->
                                                <el-table-column align="center" width="180" label="价格" v-if="true">
                                                   <template slot-scope="scope">
                                                      <div v-if="sendDataInfo.specialList[scope.$index].clType === 1">
                                                         <div
                                                            v-for="(price, priceIndex) in getPriceConditions(scope.$index)"
                                                            :key="'price-' + priceIndex" class="price-condition-item">
                                                            <div class="price-input-group">
                                                               <el-input
                                                                  v-model.number="sendDataInfo.specialList[scope.$index].priceConditions[priceIndex].price"
                                                                  placeholder="价格" 
                                                                  class="price-input"
                                                                  type="number"
                                                                  :step="0.01"
                                                                  :precision="2"
                                                                  @blur="formatPrice(scope.$index, priceIndex)">
                                                               </el-input>
                                                               <div class="condition-actions">
                                                                  <el-button
                                                                     v-if="priceIndex === getPriceConditions(scope.$index).length - 1"
                                                                     type="text" icon="el-icon-plus"
                                                                     @click="addPriceCondition(scope.$index)"
                                                                     class="add-condition-btn">
                                                                  </el-button>
                                                                  <el-button
                                                                     v-if="getPriceConditions(scope.$index).length > 1"
                                                                     type="text" icon="el-icon-delete"
                                                                     @click="removePriceCondition(scope.$index, priceIndex)"
                                                                     class="remove-condition-btn">
                                                                  </el-button>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                      <span v-else>-</span>
                                                   </template>
                                                </el-table-column>

                                                <!-- 折扣要求 - 仅当优惠方式为按折扣促销时显示 -->
                                                <el-table-column align="center" width="180" label="折扣" v-if="true">
                                                   <template slot-scope="scope">
                                                      <div v-if="sendDataInfo.specialList[scope.$index].clType === 2">
                                                         <div
                                                            v-for="(discount, discountIndex) in getDiscountConditions(scope.$index)"
                                                            :key="'discount-' + discountIndex"
                                                            class="discount-condition-item">
                                                            <div class="discount-input-group">
                                                               <el-input-number
                                                                  v-model="sendDataInfo.specialList[scope.$index].discountConditions[discountIndex].discount"
                                                                  :precision="2" :step="0.01" :min="0" :max="1"
                                                                  size="mini" placeholder="折扣" class="discount-input"
                                                                  controls-position="right">
                                                               </el-input-number>
                                                               <div class="condition-actions">
                                                                  <el-button
                                                                     v-if="discountIndex === getDiscountConditions(scope.$index).length - 1"
                                                                     type="text" icon="el-icon-plus"
                                                                     @click="addDiscountCondition(scope.$index)"
                                                                     class="add-condition-btn">
                                                                  </el-button>
                                                                  <el-button
                                                                     v-if="getDiscountConditions(scope.$index).length > 1"
                                                                     type="text" icon="el-icon-delete"
                                                                     @click="removeDiscountCondition(scope.$index, discountIndex)"
                                                                     class="remove-condition-btn">
                                                                  </el-button>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                      <span v-else>-</span>
                                                   </template>
                                                </el-table-column>

                                                <el-table-column align="center" width="200" label="生产厂家">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].manufacturer }}</span>
                                                   </template>
                                                </el-table-column>
                                                <!-- 产地（促销类型为21时显示） -->
                                                <el-table-column align="center" width="120" label="产地">
                                                   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].placeorigin }}</span>
                                                   </template>
                                                </el-table-column>
                                             </el-table>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                           </div>



                        </div>



                        <!-- 右侧固定区域 -->
                        <div class="right-section">
                           <div class="section-title">
                              <span class="title-text">超量促销</span>
                           </div>
                           <div class="right-content">
                              <!-- 绑定门店 -->
                              <div class="store-section">
                                 <div class="section-header">
                                    <div class="header-content">
                                       <i class="el-icon-office-building"></i>
                                       <span>绑定门店</span>
                                    </div>
                                    <div class="selection-count">
                                       {{ selectedStores.length }}/{{ storeList.length }}
                                    </div>
                                 </div>
                                 <div class="table-container">
                                    <el-table :data="storeList" size="mini" height="320"
                                       @selection-change="handleStoreSelectionChange" @row-click="handleStoreClick"
                                       ref="storeTable" class="elegant-table">
                                       <el-table-column type="selection" width="45"></el-table-column>
                                       <el-table-column prop="storeName" label="门店名称" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-name-text">{{ scope.row.storeName || scope.row.name
                                             }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeType" label="门店类型" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-type-text">{{ scope.row.storeType || scope.row.type ||
                                                '未知' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="phone" label="联系电话" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-phone-text">{{ scope.row.storePhone || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeAddress" label="门店地址" width="150">
                                          <template slot-scope="scope">
                                             <span class="store-address-text">{{ scope.row.storeAddress ||
                                                scope.row.address || scope.row.location || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeArea" label="门店区域" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-area-text">{{ scope.row.storeArea || scope.row.area ||
                                                scope.row.region || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                    </el-table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
      </div>
      <div class="foot">
         <div>
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()" v-if="!checkDisabled">保 存</el-button>
         </div>
      </div>
      <!-- 检索阶梯 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 通用名称列表 -->
      <el-dialog :title="actionData.cate === 0 ? '添加通用商品明细' : '编辑通用商品明细'" v-if="shopListVisible"
         :visible.sync="shopListVisible" :modal-append-to-body="true" :append-to-body="true" width="75%" center
         @close="resetShopModalState">
         <div class="store-modal-content">
            <!-- 搜索条件 -->
            <div class="search-container" style="margin-bottom: 20px;">
               <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                  <el-form-item label="商品名称">
                     <el-input v-model="searchForm.bgmName" placeholder="请输入商品名称" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="商品分类">
                     <el-select v-model="searchForm.btId" placeholder="请选择商品分类" clearable>
                        <el-option v-for="item in bgmTypeList" :key="item.btId" :label="item.btName"
                           :value="item.btId"></el-option>
                     </el-select>
                  </el-form-item>
                  <el-form-item label="生产商">
                     <el-input v-model="searchForm.manufacturer" placeholder="请输入生产商" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchCommonNames">查询</el-button>


                  </el-form-item>
               </el-form>
            </div>

            <!-- 表格 -->
            <el-table :data="commonNamesList" border style="width: 100%" height="400" fit
               @selection-change="handleCommonNameSelectionChange" @row-click="handleRowGiftModalClick"
               ref="commonNamesTable">
               <el-table-column type="selection" width="55" fixed>
               </el-table-column>
               <el-table-column prop="bgmCode" label="商品编码" min-width="120">
               </el-table-column>
               <el-table-column prop="bgmName" label="通用名称" min-width="180" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="spec" label="规格" min-width="150" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="manufacturer" label="生产商" min-width="180" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="placeorigin" label="产地" min-width="120" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="maxPsprice" label="最大进价" min-width="120">
               </el-table-column>
               <el-table-column prop="retailPrice" label="统一零售价" min-width="120">
               </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: right;">
               <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="currentPage" :page-sizes="[30, 50, 100, 200]" :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper" :total="total">
               </el-pagination>
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="closeShopModal">取 消</el-button>
            <el-button type="primary" @click="submitCommonNameSelection">确 定</el-button>
            <el-button type="success" @click="selectAllCommonNames">选择全部</el-button>
         </div>
      </el-dialog>

      <!-- 促销周期和日期选择弹窗 -->
      <el-dialog v-if="promotionDialogVisible" title="促销周期和日期设置" :visible.sync="promotionDialogVisible" width="60%" center
      :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="false" custom-class="promotion-dialog" :modal="true" :lock-scroll="false">
         <div class="promotion-selection-container">
            <!-- 促销周期选择 -->
            <div class="selection-section">
               <div class="section-header">
                  <h4>促销周期</h4>
                  <div class="selection-actions">
                     <el-button size="mini" @click="selectAllWeekDays">全选</el-button>
                     <el-button size="mini" @click="clearAllWeekDays">不全选</el-button>
                  </div>
               </div>
               <div class="checkbox-group">
                  <el-checkbox-group v-model="tempWeekDays">
                     <el-checkbox-button v-for="item in mzWeekDays" :label="item.value" :key="item.value">
                        {{ item.label }}
                     </el-checkbox-button>
                  </el-checkbox-group>
               </div>
            </div>

            <!-- 促销日期选择 -->
            <div class="selection-section">
               <div class="section-header">
                  <h4>促销日期</h4>
                  <div class="selection-actions">
                     <el-button size="mini" @click="selectAllMonthDays">全选</el-button>
                     <el-button size="mini" @click="clearAllMonthDays">不全选</el-button>
                  </div>
               </div>
               <div class="checkbox-group">
                  <el-checkbox-group v-model="tempMonthDays">
                     <el-checkbox-button v-for="item in mzMonthDays" :label="item.value" :key="item.value">
                        {{ item.label }}
                     </el-checkbox-button>
                  </el-checkbox-group>
               </div>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="promotionDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmPromotionSelection">确 定</el-button>
         </div>
      </el-dialog>
      <!-- 导入EXCEL弹窗 -->
     <el-dialog :title="title" :visible.sync="UploadVisible" width="30%" :modal-append-to-body="true" :append-to-body="true">
         <initDataUpload ref="initDataUpload" :url="url" :importType="importType" :listShow="true" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
      <!-- 方案选择弹窗 -->
      <el-dialog v-if="schemeDialogVisible" title="选择已有方案" :visible.sync="schemeDialogVisible" width="80%" center 
         :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="false" 
         custom-class="promotion-dialog" :modal="true" :lock-scroll="false">
         <div class="scheme-dialog-content">
            <!-- 搜索区域 -->
            <div class="search-section">
               <el-form :model="schemeSearchForm" inline size="mini">
                  <el-form-item label="方案名称">
                     <el-input v-model="schemeSearchForm.planName" placeholder="请输入方案名称" clearable
                        @keyup.enter.native="searchSchemes"></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchSchemes">
                        <i class="el-icon-search"></i> 搜索
                     </el-button>
                     <el-button @click="resetSchemeSearch">
                        <i class="el-icon-refresh"></i> 重置
                     </el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 方案列表 -->
            <div class="scheme-list-section">
               <el-table :data="schemeList" height="400" border @row-click="handleSchemeRowClick">
                  <el-table-column label="选择" width="80" align="center">
                     <template slot-scope="scope">
                        <el-radio v-model="selectedSchemeIndex" :label="scope.$index" border size="mini">
                           <i class="el-icon-thumb"></i>
                        </el-radio>
                     </template>
                  </el-table-column>
                  <el-table-column prop="planId" label="方案编码" width="200" show-overflow-tooltip>
                     <!-- <template slot-scope="scope">
                        <a @click="toDetail(scope.row)">{{ scope.row.planId }}</a>
                     </template> -->
                  </el-table-column>
                  <el-table-column prop="planName" label="方案名称" width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="planDesc" label="方案描述" min-width="200" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column prop="planType" label="促销类型" width="120" align="center">
                     <template slot-scope="scope">
                        {{ scope.row.planType == 1 ? '促销赠送' : scope.row.planType == 2 ? '促销调价' : '超量促销' }}
                     </template>
                  </el-table-column> -->
                  <el-table-column prop="state" label="方案状态" width="120" align="center">
                     <template slot-scope="scope">
                        <el-tag
                           :type="scope.row.state == -1 ? 'danger' : scope.row.state == 0 ? 'info' : scope.row.state == 1 ? 'primary' : 'success'">
                           {{ scope.row.state == -1 ? '审核驳回' : scope.row.state == 0 ? '初始' : scope.row.state ==
                              1 ? '提交' : '审核通过' }}
                        </el-tag>
                     </template>
                  </el-table-column>
                  <el-table-column prop="startDate" label="开始日期" width="120" align="center">
                     <template slot-scope="scope">
                        {{ formatDate(scope.row.startDate) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="endDate" label="结束日期" width="120" align="center">
                     <template slot-scope="scope">
                        {{ formatDate(scope.row.endDate) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="createTime" label="创建时间" width="150" align="center">
                     <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                     </template>
                  </el-table-column>
               </el-table>

               <!-- 分页 -->
               <div class="pagination-section">
                  <el-pagination @size-change="handleSchemeSizeChange" @current-change="handleSchemeCurrentChange"
                     :current-page="schemeCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="schemePageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="schemeTotal">
                  </el-pagination>
               </div>
            </div>
         </div>

         <div slot="footer" class="dialog-footer">
            <el-button @click="schemeDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="applySelectedScheme" :disabled="selectedSchemeIndex === null">
               应用方案
            </el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import initDataUpload from "../byComponents/initDataUpload.vue";
export default {
   props: ["actionData"],
   name: "cxExcessAction",
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      initDataUpload,
   },
   data() {
      return {
         dataActionBox: {
            actionType: 0, // 0新增，1修改
         },
         checkDisabled: false,
         sendDataInfo: {
            planName: "", // 方案名称
            startDate: new Date().getTime(), // 开始日期，默认为当前日期
            endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(), // 结束日期，默认为一周后
            dayStartTime: "00:00:00", // 开始时间
            dayEndTime: "23:59:59", // 结束时间
            memReq: 1, // 会员要求 1不限 2会员卡类型 3会员积分
            clType: 1, // 变价规则 1达到数量整体变价 2按数量递增变价
            clRoundType: 1, // 是否循环促销 1：仅促销一次、2：循环促销条件、3：按最后一个优惠处理
            planDesc: "", // 方案描述
            specialList: [], // 明细列表
        
            planType: 3, // 促销方案类型 超量促销
            mzWeekDays: ['1', '2', '3', '4', '5', '6', '7'], // 促销周期
            mzMonthDays: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'], // 促销日期
            selectedCardTypeIds: [], // 选中的会员卡类型ID数组
         },
         mzWeekDays: [
            { label: "周一", value: '1' },
            { label: "周二", value: '2' },
            { label: "周三", value: '3' },
            { label: "周四", value: '4' },
            { label: "周五", value: '5' },
            { label: "周六", value: '6' },
            { label: "周日", value: '7' },
         ],
         mzMonthDays: [
            { label: "1日", value: '1' },
            { label: "2日", value: '2' },
            { label: "3日", value: '3' },
            { label: "4日", value: '4' },
            { label: "5日", value: '5' },
            { label: "6日", value: '6' },
            { label: "7日", value: '7' },
            { label: "8日", value: '8' },
            { label: "9日", value: '9' },
            { label: "10日", value: '10' },
            { label: "11日", value: '11' },
            { label: "12日", value: '12' },
            { label: "13日", value: '13' },
            { label: "14日", value: '14' },
            { label: "15日", value: '15' },
            { label: "16日", value: '16' },
            { label: "17日", value: '17' },
            { label: "18日", value: '18' },
            { label: "19日", value: '19' },
            { label: "20日", value: '20' },
            { label: "21日", value: '21' },
            { label: "22日", value: '22' },
            { label: "23日", value: '23' },
            { label: "24日", value: '24' },
            { label: "25日", value: '25' },
            { label: "26日", value: '26' },
            { label: "27日", value: '27' },
            { label: "28日", value: '28' },
            { label: "29日", value: '29' },
            { label: "30日", value: '30' },
            { label: "31日", value: '31' },
         ],
         formDataList: [],
         showTabs: "",
         DialogVisible: false, //判断是否打开检索阶梯弹框
         seTitle: "", //检索阶梯的名称
         seType: "", //检索阶梯查询条件字段
         seWidth: "", //检索阶梯弹框的宽度
         sField: "", //赋值字段
         parentSearchData: {}, //检索阶梯补充的查询列表的查询条件
         selectedDataIndex: 0, // 选中的明细索引
         selectedDataRows: [], // 选中的明细行数据
         selectedGiftIndex: 0, // 选中的赠品索引
         detaislDataInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            clType: 1, // 默认优惠方式为按价格促销
            num: "", // 数量要求
            price: "", // 价格要求
            discount: "", // 折扣要求
            priceConditions: [{ num: '', price: '' }], // 价格条件列表
            discountConditions: [{ num: '', discount: '' }], // 折扣条件列表
            totalNum: "", // 总数量
            usedNum: 0, // 已使用数量
            dayPerOrder: "", // 每日限购
            numPerOrder: "", // 每单限购
            isMem: 0, // 是否会员价
            memPrice: "", // 会员价
            pointMultiply: "" // 积分倍数
         },
         giftDetailsInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            barcode: "",
            placeorigin: "",

         },
         seIndex: 0, // 当前操作的明细索引
         UploadVisible: false, // 导入EXCEL弹窗是否显示
         title: '', // 导入弹窗标题
         url: '', // 导入地址
         // 会员卡类型相关数据
         cardTypeList: [], // 会员卡类型列表
         selectedCardTypes: [], // 选中的会员卡类型
         selectedCardTypeIds: [], // 选中的会员卡类型ID数组（用于复选框）
         // 门店相关数据
         storeList: [], // 门店列表
         selectedStores: [], // 选中的门店
         // 会员相关数据
         memberList: [], // 会员列表
         selectedMembers: [], // 选中的会员
         selectedMemberIds: [], // 选中的会员ID数组（用于复选框）
         // -----------------通用名称列表-----------------
         bgmTypeList: [],
         searchForm: {
            bgmName: '',
            manufacturer: '',
            btId: ''
         },
         shopListVisible: false,
         commonNamesList: [],
         currentPage: 1,
         pageSize: 30,
         total: 0,
         selectedCommonNames: [],
         allCommonNamesList: [],
         selectedAllCommonNames: false,
         allCommonNamesIds: [],
         // 导入EXCEL相关数据
         importType: 'sellPlanImportCLCXExcel',
         // 促销周期和日期选择弹窗相关
         promotionDialogVisible: false,
         tempWeekDays: [],
         tempMonthDays: [],

             // 方案选择弹窗相关
             schemeDialogVisible: false,
         schemeList: [], // 历史方案列表
         schemeCurrentPage: 1,
         schemePageSize: 10,
         schemeTotal: 0,
         selectedSchemeIndex: 0, // 选中的方案索引
         schemeSearchForm: {
            planName: '',
            planType: ''
         },
      }
   },
   computed: {
      // 格式化开始日期显示
      formattedStartDate() {
         if (!this.sendDataInfo.startDate) return '未选择';
         return this.$moment(this.sendDataInfo.startDate).format('YYYY-MM-DD');
      },
      // 格式化结束日期显示
      formattedEndDate() {
         if (!this.sendDataInfo.endDate) return '未选择';
         return this.$moment(this.sendDataInfo.endDate).format('YYYY-MM-DD');
      },
      // 全选状态
      isAllSelected: {
         get() {
            return this.selectedCardTypeIds.length === this.cardTypeList.length && this.cardTypeList.length > 0;
         },
         set(value) {
            if (value) {
               this.selectedCardTypeIds = this.cardTypeList.map(item => item.capId);
               this.selectedCardTypes = [...this.cardTypeList];
            } else {
               this.selectedCardTypeIds = [];
               this.selectedCardTypes = [];
            }
         }
      },

      // 会员全选状态
      isAllMembersSelected: {
         get() {
            return this.selectedMemberIds.length === this.memberList.length && this.memberList.length > 0;
         },
         set(value) {
            if (value) {
               this.selectedMemberIds = this.memberList.map(item => item.memberId);
               this.selectedMembers = [...this.memberList];
            } else {
               this.selectedMemberIds = [];
               this.selectedMembers = [];
            }
         }
      },

      // 促销周期显示文本
      weekDaysDisplayText() {
         if (!this.sendDataInfo.mzWeekDays || this.sendDataInfo.mzWeekDays.length === 0) {
            return '请选择促销周期';
         }
         const selectedLabels = this.mzWeekDays
            .filter(item => this.sendDataInfo.mzWeekDays.includes(item.value))
            .map(item => item.label);
         return selectedLabels.join('、');
      },

      // 促销日期显示文本
      monthDaysDisplayText() {
         if (!this.sendDataInfo.mzMonthDays || this.sendDataInfo.mzMonthDays.length === 0) {
            return '请选择促销日期';
         }
         const selectedLabels = this.mzMonthDays
            .filter(item => this.sendDataInfo.mzMonthDays.includes(item.value))
            .map(item => item.label);
         return selectedLabels.join('、');
      },


   },
   watch: {
      'sendDataInfo.clType': {
         handler(newVal) {
            // 当变价规则为"达到数量整体变价"时，设置循环促销为"仅促销一次"
            if (newVal === 1) {
               this.sendDataInfo.clRoundType = 1;
            }
         },
         immediate: true
      }
   },
   methods: {
           // 格式化日期
           formatDate(timestamp) {
         if (!timestamp) return '未设置';
         return this.$moment(timestamp).format('YYYY-MM-DD');
      },
      formatDateTime(timestamp) {
         if (!timestamp) return '未设置';
         return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      },
      // 格式化价格为两位小数
      formatPrice(rowIndex, priceIndex) {
         const price = this.sendDataInfo.specialList[rowIndex].priceConditions[priceIndex].price;
         if (price !== null && price !== undefined && price !== '') {
            const formattedPrice = parseFloat(price).toFixed(2);
            this.$set(this.sendDataInfo.specialList[rowIndex].priceConditions[priceIndex], 'price', parseFloat(formattedPrice));
         }
      },
      async openBox() {

         if (this.actionData.cate == 0) {
            this.showTabs = "新增"
            this.formDataList = [
               {
                  jciName: "新增",
                  jurconfigform: [],
               },
            ]
         } else {
            // 回显数据
            console.log(this.actionData.oldData, 'this.actionData.oldData');
            this.checkDisabled = this.actionData?.checkDisabled ? true : false
            console.log(this.checkDisabled, 'this.checkDisabled');

            if (this.actionData.oldData) {
               for (let key in this.actionData.oldData) {
                  // 特殊处理周期类型
                  if (key === "roundWeek") {
                     const roundWeek = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzWeekDays = roundWeek;
                  } else if (key === "roundDay") {
                     const roundDay = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzMonthDays = roundDay;
                  } else if (key === "dayStartTime" || key === "dayEndTime") {
                     // 特殊处理每日时间字段，将秒数转换为时间字符串
                     const seconds = this.actionData.oldData[key];
                     if (seconds !== null && seconds !== undefined && seconds !== "") {
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                        this.$set(this.sendDataInfo, key, timeString);
                     } else {
                        this.$set(this.sendDataInfo, key, "");
                     }
                  } else {
                     this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                  }
               }


               // 参与商品列表
               if (this.actionData.oldData.clList && this.actionData.oldData.clList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.clList.map(item =>
                     this.convertToSpecialListItem(item, false)
                  );
                  console.log('回显商品列表:', this.sendDataInfo.specialList);
               }



               // 回显会员卡类型和门店选择
               this.$nextTick(async () => {
                  // 回显会员卡类型选择
                  if (this.actionData.oldData.mcTypeList && this.actionData.oldData.mcTypeList.length > 0) {
                     await this.loadCardTypeData();
                     // 获取所有需要选中的卡类型ID
                     const selectedIds = this.actionData.oldData.mcTypeList.map(item => item.capId);
                     // 设置选中状态
                     this.selectedCardTypeIds = selectedIds;
                     this.sendDataInfo.selectedCardTypeIds = selectedIds;
                     // 设置选中的对象数组
                     this.selectedCardTypes = this.cardTypeList.filter(item => selectedIds.includes(item.capId));
                     console.log('已选中会员卡类型:', this.selectedCardTypes.length);
                     
                     // 设置表格选中状态
                     this.$nextTick(() => {
                        if (this.$refs.cardTypeTable) {
                           this.selectedCardTypes.forEach(cardType => {
                              this.$refs.cardTypeTable.toggleRowSelection(cardType, true);
                           });
                        }
                     });
                  }



                  // 回显门店选择
                  if (this.actionData.oldData.storeList && this.actionData.oldData.storeList.length > 0) {
                     await this.loadStoreData();
                     const selectedStoreIds = this.actionData.oldData.storeList;
                     console.log(this.storeList, 'this.storeList');

                     // 使用 nextTick 确保 DOM 已更新
                     await this.$nextTick();
                     setTimeout(() => {
                     // 确保 storeTable 存在
                     if (this.$refs.storeTable) {
                        this.storeList.forEach(item => {
                           const itemId = item.id || item.storeId;
                           // 检查是否存在匹配的门店ID
                           const isSelected = selectedStoreIds.some(store =>
                              (store.id === itemId || store.storeId === itemId)
                           );
                           if (isSelected) {
                              this.$refs.storeTable.toggleRowSelection(item, true);
                           }
                        });
                     }
                  }, 200);
                  }
               })
            }

            this.formDataList = [
               {
                  jciName: "编辑",
                  jurconfigform: [],
               },
            ]
            this.showTabs = "编辑"
         }

         this.dataActionBox.actionType = this.actionData.cate
         this.init()

      },
      // 初始化数据
      init() {
         // 只有在新增模式下才清空明细数据
         if (this.dataActionBox.actionType == 0) {
            this.sendDataInfo.specialList = [];
            this.sendDataInfo.giftList = [];
            this.sendDataInfo.roundDay = "";
            this.memDayIds = [];
            // 设置默认日期
            this.sendDataInfo.startDate = new Date().getTime(); // 当前日期
            this.sendDataInfo.endDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(); // 一周后
         }

         // 初始化明细默认数据
         this.detaislDataInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            clType: 1, // 默认优惠方式为按价格促销
            num: "", // 数量要求
            price: "", // 价格要求
            discount: "", // 折扣要求
            priceConditions: [{ num: '', price: '' }], // 价格条件列表
            discountConditions: [{ num: '', discount: '' }], // 折扣条件列表
            totalNum: "", // 总数量
            usedNum: 0, // 已使用数量
            dayPerOrder: "", // 每日限购
            numPerOrder: "", // 每单限购
            isMem: 0, // 是否会员价
            memPrice: "", // 会员价
            pointMultiply: "" // 积分倍数
         };

         // 初始化赠品默认数据
         this.giftDetailsInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            maxPsprice: "",
            barcode: "",
            placeorigin: "",

         };

         // 加载会员卡类型、会员和门店数据
         this.loadCardTypeData();
         // this.loadMemberData();
         this.loadStoreData();
      },
      // 新增明细
      addDetails() {
         // if (!this.sendDataInfo.specialList) {
         //    this.$set(this.sendDataInfo, 'specialList', []);
         // }
         // const newItem = JSON.parse(JSON.stringify(this.detaislDataInfo));
         // this.sendDataInfo.specialList.push(newItem);

         this.searchCommonNames()
         this.shopListVisible = true
      },
      // excel导入商品
      importDetails() {
         // 导入
         this.title = '导入参与商品'
         this.importType = 'sellPlanImportCLCXExcel'
         this.url = 'sellPlan/importCLCXExcel'
         this.UploadVisible = true
      },
      // 下载模版
      downloadTemplate() {
         window.location.href = `${this.$store.getters.getConfig.requestUrl}/sellPlan/downloadCLCXTemplate`
      },
      // -----------------通用名称列表-----------------
      searchCommonNames() {
         this.currentPage = 1;
         this.getDataCommonNames();
      },
      chooseAll() {

         this.pageSize = 3000
         this.getDataCommonNames();

      },
      async getDataCommonNames() {
         console.log(this.tjGroupId, 'this.tjGroupId');

         let params = {
            businessId: "",
            bgmName: this.searchForm.bgmName,
            manufacturer: this.searchForm.manufacturer,
            btId: this.searchForm.btId,
            page: this.currentPage,
            rows: this.pageSize,
            groupId: this.tjGroupId,
            start: '',
            end: '',
            ormId: 0
         };
         let responseData = await this.$http.getBgmListByType(params);
         if (responseData.status == 200) {
            this.commonNamesList = responseData.result.list;
            this.total = responseData.result.total;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      handleCommonNameSelectionChange(val) {
         this.selectedCommonNames = val.map(item => item.bgmId);
      },
      submitCommonNameSelection() {
         // 判断是否有选中的商品
         if ((!this.selectedCommonNames || this.selectedCommonNames.length === 0) &&
            (!this.selectedAllCommonNames || !this.allCommonNamesIds || this.allCommonNamesIds.length === 0)) {
            this.$message({
               message: "请至少选择一个商品",
               type: "warning"
            });
            return;
         }

         // 根据是否选择全部，确定要处理的商品数据
         let processItems = [];
         let processCount = 0;

         if (this.selectedAllCommonNames && this.allCommonNamesList && this.allCommonNamesList.length > 0) {
            // 处理全部选择的情况
            processItems = this.allCommonNamesList;
            processCount = processItems.length;
         } else {
            // 处理普通选择的情况
            processItems = this.commonNamesList.filter(item =>
               this.selectedCommonNames.includes(item.bgmId)
            );
            processCount = processItems.length;
         }

         // 添加商品到列表
         let addedCount = 0;
         processItems.forEach(item => {
            // 检查是否已存在相同的商品
            const exists = this.sendDataInfo.specialList.some(
               existingItem => existingItem.bgmId === item.bgmId
            );
            console.log(exists, 'exists');

            if (!exists) {
               // 添加到商品列表
               this.sendDataInfo.specialList.push({
                  bgmId: item.bgmId,
                  bgmName: item.bgmName,
                  bgmCode: item.bgmCode,
                  spec: item.spec,
                  manufacturer: item.manufacturer,
                  salesPrice: item.salesPrice,
                  memberPrice: item.memberPrice,
                  retailPrice: item.retailPrice,
                  maxPsprice: item.maxPsprice,
                  placeorigin: item.placeorigin,
                  isMem: 0,
                  totalNum: 0,
                  numPerOrder: 0,
                  price: 0,
                  memPrice: 0,
                  dayPerOrder: "",
                  pointMultiply: 1,
                  isDiscount: 0,
                  clType: 1,
                  priceConditions: [{ num: '', price: '' }],
                  discountConditions: [{ num: '', discount: '' }],
               });
               addedCount++;
            }
         });

         this.$message({
            message: `已添加 ${addedCount} 个商品到${this.isExcludeGoodsMode ? '不参与' : '参与'}商品列表`,
            type: "success"
         });

         // 关闭对话框
         this.shopListVisible = false;

         // 重置选择状态
         this.resetShopModalState();
      },

      // 重置商品选择弹窗状态
      resetShopModalState() {
         this.selectedAllCommonNames = false;
         this.allCommonNamesList = [];
         this.allCommonNamesIds = [];
         this.selectedCommonNames = [];
      },

      // 关闭商品选择弹窗
      closeShopModal() {
         this.shopListVisible = false;
         this.resetShopModalState();
      },
      handleSizeChange(val) {
         this.pageSize = val;
         this.getDataCommonNames();
      },
      handleCurrentChange(val) {
         this.currentPage = val;
         this.getDataCommonNames();
      },

      handleRowGiftModalClick(row) {
         // 点击商品名称选中数据
         console.log(row, 'rowGiftModal');
         this.$refs.commonNamesTable.toggleRowSelection(row);
      },

      handleRowShopModalClick(row) {
         // 点击商品名称选中数据
         console.log(row, 'rowShopModal');
         this.$refs.mxTableRef.toggleRowSelection(row);
      },

      async selectAllCommonNames() {
         // 显示加载提示
         const loading = this.$loading({
            lock: true,
            text: '正在加载数据...',
            spinner: 'el-icon-loading',
         });
         
         try {
            // 保存当前查询条件
            const params = {
               businessId: "",
               bgmName: this.searchForm.bgmName,
               manufacturer: this.searchForm.manufacturer,
               btId: this.searchForm.btId,
               page: 1,
               rows: 3000, // 一次性获取大量数据
               groupId: this.tjGroupId,
               start: '',
               end: '',
               ormId: 0
            };

            // 获取所有数据
            let responseData = await this.$http.getBgmListByType(params);
            if (responseData.status == 200) {

               // 保存所有商品数据
               this.allCommonNamesList = responseData.result.list || [];

               // 设置选中状态
               if (this.$refs.commonNamesTable) {
                  // 先清空当前选中状态
                  this.$refs.commonNamesTable.clearSelection();

                  // 设置当前页面的商品为选中状态
                  this.commonNamesList.forEach(row => {
                     this.$refs.commonNamesTable.toggleRowSelection(row, true);
                  });
               }

               // 保存所有商品的ID
               this.selectedAllCommonNames = true;
               this.allCommonNamesIds = this.allCommonNamesList.map(item => item.bgmId);
            } else {
               this.$message({
                  message: responseData.message || "获取全部商品失败",
                  type: "error"
               });
            }
         } catch (error) {
            console.error("获取全部商品出错:", error);
            this.$message({
               message: "获取全部商品出错",
               type: "error"
            });
         } finally {
            loading.close();
         }
      },
      // 删除明细
      deleteDetails() {
         if (this.selectedDataRows.length === 0) {
            return this.$message({
               message: "请选择要删除的商品",
               type: "warning",
            });
         }

         // 获取选中行的索引
         const selectedIds = this.selectedDataRows.map(row => row.bgmId);

         // 从后向前删除，避免索引变化问题
         const newSpecialList = this.sendDataInfo.specialList.filter(item => !selectedIds.includes(item.bgmId));
         this.sendDataInfo.specialList = newSpecialList;

         this.$message({
            message: `已删除 ${this.selectedDataRows.length} 个商品`,
            type: "success",
         });

         // 清空选择
         this.selectedDataRows = [];
         if (this.$refs.mxTableRef) {
            this.$refs.mxTableRef.clearSelection();
         }
      },
      // 处理表格选择变化
      handleSelectionChange(selection) {
         this.selectedDataRows = selection;
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.specialList[index + 1] != undefined) {
               // 根据促销类型选择焦点字段
               const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : "bgmName";
               if (this.$refs[focusField] && this.$refs[focusField][index + 1]) {
                  this.$refs[focusField][index + 1].focus();
               }
               this.selectedDataIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  if (refsElTable) {
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.specialList[this.selectedDataIndex]
                     );
                  }
               });
               return;
            }
            this.addDetails();
            return;
         }
         // 根据促销类型选择焦点字段
         const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : field;
         if (this.$refs[focusField] && this.$refs[focusField][index]) {
            this.$refs[focusField][index].focus();
         }
      },
      // 双击明细行
      openDateilsBox(row, column, event) {
         this.editDateilsIndex = row.index;
         this.specialList = JSON.parse(JSON.stringify(row));
      },
      handleRowClick(row) {
         this.selectedDataIndex = this.sendDataInfo.specialList.findIndex(item => item.bgmId === row.bgmId);
      },
      //获取检索阶梯弹框宽度
      getSeWidth(e) {
         this.seWidth = e + "%"
      },
      //获取检索阶梯弹框名称
      getSearchName(e) {
         this.seTitle = e
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.seId = sId //检索阶梯Id
         this.sField = sField //赋值字段
         this.DialogVisible = true //判断是否打开弹框
         this.seType = type
         this.seIndex = index // 设置当前操作的明细索引
         console.log('openSearch - seIndex:', this.seIndex, 'seType:', this.seType);
      },
      //检索阶梯返回的数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false
            console.log('changeInputModel - seType:', this.seType, 'seIndex:', this.seIndex, 'val:', val);

            if (this.seType == "bgmName") {
               // 处理商品搜索返回的数据
               if (this.seIndex !== undefined) {
                  // 第一个表单
                  console.log('处理第一个表单，索引:', this.seIndex);
                  for (let fkey in this.sendDataInfo.specialList[this.seIndex]) {
                     for (let vkey in val) {
                        if (fkey == vkey) {
                           this.$set(
                              this.sendDataInfo.specialList[this.seIndex],
                              fkey,
                              val[vkey]
                           );
                        }
                     }
                  }
                  // 设置商品相关信息
                  this.sendDataInfo.specialList[this.seIndex].bgmId = val.bgmId;
                  this.sendDataInfo.specialList[this.seIndex].bgmName = val.bgmName;
                  this.sendDataInfo.specialList[this.seIndex].bgmCode = val.bgmCode;
                  this.sendDataInfo.specialList[this.seIndex].bgmSpec = val.bgmSpec;
                  this.sendDataInfo.specialList[this.seIndex].spec = val.spec;
                  this.sendDataInfo.specialList[this.seIndex].manufacturer = val.manufacturer;
                  this.sendDataInfo.specialList[this.seIndex].retailPrice = val.retailPrice;
                  this.sendDataInfo.specialList[this.seIndex].maxPsprice = val.maxPsprice;
                  this.sendDataInfo.specialList[this.seIndex].price = val.price;
                  this.sendDataInfo.specialList[this.seIndex].barcode = val.barcode;
                  this.sendDataInfo.specialList[this.seIndex].placeorigin = val.placeorigin;



                  this.sendDataInfo.specialList[this.seIndex].isDiscount = 0;
                  // 初始化超量促销相关字段
                  this.sendDataInfo.specialList[this.seIndex].clType = 1; // 默认按价格促销
                  this.sendDataInfo.specialList[this.seIndex].num = ""; // 数量要求
                  this.sendDataInfo.specialList[this.seIndex].price = ""; // 价格要求
                  this.sendDataInfo.specialList[this.seIndex].discount = ""; // 折扣要求
                  // 初始化价格条件和折扣条件列表
                  this.sendDataInfo.specialList[this.seIndex].priceConditions = [{ num: '', price: '' }];
                  this.sendDataInfo.specialList[this.seIndex].discountConditions = [{ num: '', discount: '' }];
               }
            } else {
               this.paramValue(val) //赋值字段，赋值
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",")
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item]
         })
      },
      //关闭提取、检索阶梯弹框关闭 创建键盘事件
      closeChild() {
         addEventListener("keyup", this.keyUp) //创建监听键盘事件
      },
      async sendDataAction() {
         // 表单验证
         this.$refs.sendDataInfo.validate(async (valid) => {
            if (valid) {
               // 验证开始日期和结束日期
               if (this.sendDataInfo.startDate && this.sendDataInfo.endDate) {
                  if (this.sendDataInfo.endDate < this.sendDataInfo.startDate) {
                     this.$message({
                        message: "结束日期不能小于开始日期",
                        type: "error",
                     });
                     return false;
                  }
                  // 处理开始日期和结束日期，去掉时分秒
                  const startDate = new Date(this.sendDataInfo.startDate);
                  const endDate = new Date(this.sendDataInfo.endDate);

                  // 设置时间为当天的 00:00:00
                  startDate.setHours(0, 0, 0, 0);
                  endDate.setHours(0, 0, 0, 0);

                  // 更新时间戳
                  this.sendDataInfo.startDate = startDate.getTime();
                  this.sendDataInfo.endDate = endDate.getTime();
               }
               // 验证每日开始时间和每日结束时间
               if (this.sendDataInfo.dayStartTime && this.sendDataInfo.dayEndTime) {
                  // 直接处理时间字符串格式 HH:mm:ss
                  const startParts = this.sendDataInfo.dayStartTime.split(':');
                  const endParts = this.sendDataInfo.dayEndTime.split(':');

                  const startHours = parseInt(startParts[0]) || 0;
                  const startMinutes = parseInt(startParts[1]) || 0;
                  const startSeconds = parseInt(startParts[2]) || 0;

                  const endHours = parseInt(endParts[0]) || 0;
                  const endMinutes = parseInt(endParts[1]) || 0;
                  const endSeconds = parseInt(endParts[2]) || 0;

                  // 转换为秒数进行比较
                  const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
                  const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

                  if (endTotalSeconds <= startTotalSeconds) {
                     this.$message({
                        message: "每日结束时间不能小于或等于每日开始时间",
                        type: "error",
                     });
                     return false;
                  }
               }






               // ------------------处理参数------------------
               //会员要求：会员卡类型
               if (this.sendDataInfo.memReq == 2) {
                  this.sendDataInfo.mcTypeList = this.selectedCardTypes.map(item => {
                     return item.capId
                  })
               }
               if (this.sendDataInfo.specialList.length > 0) {
                  this.sendDataInfo.clList = this.sendDataInfo.specialList.map(item => {
                     // 处理基本商品信息
                     const baseItem = {
                        bgmId: item.bgmId,
                        dayPerOrder: item.dayPerOrder,
                        isMem: item.isMem,
                        memPrice: item.memPrice,
                        numPerOrder: item.numPerOrder,
                        pointMultiply: item.pointMultiply,
                        price: item.price,
                        totalNum: item.totalNum,
                        usedNum: item.usedNum || 0,
                        clType: item.clType,
                        clRuleList: []
                     };

                     // 处理价格条件和折扣条件
                     if (item.clType === 1 && item.priceConditions && item.priceConditions.length > 0) {
                        // 按价格促销，使用价格条件
                        item.priceConditions.forEach(condition => {
                           if (condition.num && condition.price) {
                              baseItem.clRuleList.push({
                                 num: condition.num,
                                 money: condition.price
                              });
                           }
                        });
                     } else if (item.clType === 2 && item.discountConditions && item.discountConditions.length > 0) {
                        // 按折扣促销，使用折扣条件
                        item.discountConditions.forEach(condition => {
                           if (condition.num && condition.discount) {
                              baseItem.clRuleList.push({
                                 num: condition.num,
                                 rate: condition.discount
                              });
                           }
                        });
                     }

                     return baseItem;
                  })
               }


               // delete this.sendDataInfo.specialList
               console.log(this.sendDataInfo, "this.sendDataInfo");

               let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))

               // 日期周期（数字逗号隔开）
               sendData.roundDay = this.sendDataInfo.mzMonthDays ? this.sendDataInfo.mzMonthDays.join(',') : ''
               // 星期周期（数字逗号隔开）
               sendData.roundWeek = this.sendDataInfo.mzWeekDays ? this.sendDataInfo.mzWeekDays.join(',') : ''
               // 是否叠加其他促销（数字逗号隔开）

               sendData.mzPileType = this.sendDataInfo.mzPileType ? this.sendDataInfo.mzPileType.join(',') : ''
               console.log(this.selectedStores, 'this.selectedStores');

               // 门店id列表

               if (this.selectedStores && this.selectedStores.length > 0) {
                  sendData.storeIdList = this.selectedStores.map(item => item.id || item.storeId)
               }

               // 处理每日开始时间和每日结束时间，转换为秒数
               if (sendData.dayStartTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayStartTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayStartTime = hours * 3600 + minutes * 60 + seconds;
               }

               if (sendData.dayEndTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayEndTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayEndTime = hours * 3600 + minutes * 60 + seconds;
               }
                    // showType 判断什么类型促销
                    sendData.showType = 12
               try {
                  let responseData
                  // 如果是新增
                  if (this.dataActionBox.actionType == 0) {
                     responseData = await this.$http.addSellPlan(sendData)
                  }
                  // 如果是编辑
                  else if (this.dataActionBox.actionType == 1) {
                     responseData = await this.$http.updateSellPlan(sendData)
                  }

                  if (responseData.status == 200) {
                     this.$message({
                        message:
                           this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                        type: "success",
                     })
                     this.$emit("drawerCancel", false)
                     this.$emit("toDetail", responseData.result)
                  } else {
                     this.$message({
                        message: responseData.message,
                        type: "error",
                     })
                  }
               } catch (error) {
                  console.error("error", error)
                  this.$message({
                     message: "操作失败",
                     type: "error",
                  })
               }
            } else {
               this.$message({
                  message: "请填写必填项",
                  type: "error",
               })
               return false
            }
         })
      },
      drawerCancel() {
         if (this.checkDisabled) {
            this.$emit("drawerCancel", false)
         } else {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
               confirmButtonText: "确定",
               cancelButtonText: "取消",
               type: "warning",
            })
               .then(() => {
                  this.$emit("drawerCancel", false)
               })
               .catch(() => { })
         }

      },

      // 会员卡类型选择变化（右侧表格）
      handleCardTypeSelectionChange(selection) {
         this.selectedCardTypes = selection;
         // 同步更新复选框选中的ID
         this.selectedCardTypeIds = selection.map(item => item.capId);
         // 同步更新 sendDataInfo 中的字段
         this.sendDataInfo.selectedCardTypeIds = selection.map(item => item.capId);
      },

      // 门店选择变化
      handleStoreSelectionChange(selection) {
         this.selectedStores = selection;
      },

      handleStoreClick(row) {
         this.$refs.storeTable.toggleRowSelection(row);
      },

      // 会员要求变化处理
      handleMemberTypeChange() {
         // 当会员要求不是"会员积分"时，清空积分要求字段
         if (this.sendDataInfo.memReq !== 3) {
            this.sendDataInfo.memReqPoint = '';
         }
         // 当会员要求不是"会员卡类型"时，清空会员卡类型选择
         if (this.sendDataInfo.memReq !== 2) {
            this.selectedCardTypeIds = [];
            this.selectedCardTypes = [];
            this.sendDataInfo.selectedCardTypeIds = [];
         }
         // 当会员要求不是"会员"时，清空会员选择
         if (this.sendDataInfo.memReq !== 1) {
            this.selectedMemberIds = [];
            this.selectedMembers = [];
         }
      },




      handleCardTypeClick(capId) {
         const idx = this.selectedCardTypeIds.indexOf(capId);
         if (idx > -1) {
            // 已选中，取消选中
            this.selectedCardTypeIds.splice(idx, 1);
         } else {
            // 未选中，添加选中
            this.selectedCardTypeIds.push(capId);
         }
         // 同步更新选中的对象数组
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },
      // 处理单个会员卡类型复选框变化
      handleSingleCardTypeChange(capId, checked) {
         if (checked) {
            if (!this.selectedCardTypeIds.includes(capId)) {
               this.selectedCardTypeIds.push(capId);
            }
         } else {
            const index = this.selectedCardTypeIds.indexOf(capId);
            if (index > -1) {
               this.selectedCardTypeIds.splice(index, 1);
            }
         }
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },



      // 全选/取消全选会员卡类型
      toggleAllCardTypes() {
         this.$nextTick(() => {
            if (this.isAllSelected) {
               // 全选
               this.selectedCardTypeIds = [...this.cardTypeList.map(item => item.capId)];
               this.selectedCardTypes = [...this.cardTypeList];
            } else {
               // 取消全选
               this.selectedCardTypeIds = [];
               this.selectedCardTypes = [];
            }
         });
      },

      // 全选/取消全选会员
      toggleAllMembers() {
         if (this.selectedMemberIds.length === this.memberList.length) {
            // 取消全选
            this.selectedMemberIds = [];
            this.selectedMembers = [];
         } else {
            // 全选
            this.selectedMemberIds = this.memberList.map(item => item.memberId);
            this.selectedMembers = [...this.memberList];
         }
      },



      // 加载会员卡类型数据
      async loadCardTypeData() {
         try {
            let res = await this.$http.queryMemCardType({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 100,
               start: "",
               end: "",
               capName: "",
            })

            if (res.status == 200) {
               this.cardTypeList = res.result.list || []

            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员卡类型数据失败',
               type: "error",
            })
         }
      },

      // 加载会员数据
      async loadMemberData() {
         try {
            let res = await this.$http.queryMembermastList({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: "",
               end: "",
               memName: "",
               memPhone: ""

            })

            if (res.status == 200) {
               this.memberList = res.result.list || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员数据失败',
               type: "error",
            })
         }
      },

      // 加载门店数据
      async loadStoreData() {
         try {
            let res = await this.$http.storemastQueryAll({
               businessId: "",
               creater: 0,
               end: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: 0,
               storeName: "",
               storeType: ""
            })

            if (res.status == 200) {
               this.storeList = res.result || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取门店数据失败',
               type: "error",
            })
         }
      },
      // 处理变价规则变化
      handleClTypeChange(value) {
         // 如果选择"达到数量整体变价"，则固定"是否循环促销"为"仅促销一次"
         if (value === 1) {
            this.sendDataInfo.clRoundType = 1; // 设置为"仅促销一次"
         }
      },
      // 处理商品列表中的优惠方式切换
      handleClTypeChangeInList(index, clType) {
         const item = this.sendDataInfo.specialList[index];
         if (clType === 1) {
            if (!item.priceConditions || item.priceConditions.length === 0) {
               this.$set(item, 'priceConditions', [{ num: '', price: '' }]);
            }
         } else if (clType === 2) {
            if (!item.discountConditions || item.discountConditions.length === 0) {
               this.$set(item, 'discountConditions', [{ num: '', discount: '' }]);
            }
         }
      },
      // 处理循环促销变化
      handleClRoundType(value) {
         // 如果变价规则是"达到数量整体变价"，但尝试选择其他循环促销选项，则重置为"仅促销一次"
         if (this.sendDataInfo.clType === 1 && value !== 1) {
            this.$nextTick(() => {
               this.sendDataInfo.clRoundType = 1;
               this.$message({
                  message: "达到数量整体变价模式下，只能选择仅促销一次",
                  type: "warning"
               });
            });
         }
      },
      // 添加多个价格条件
      addPriceCondition(index) {
         if (!this.sendDataInfo.specialList[index].priceConditions) {
            this.$set(this.sendDataInfo.specialList[index], 'priceConditions', []);
         }
         this.sendDataInfo.specialList[index].priceConditions.push({
            num: '',
            price: ''
         });
      },

      // 获取价格条件
      getPriceConditions(index) {
         return this.sendDataInfo.specialList[index].priceConditions || [];
      },

      // 移除价格条件
      removePriceCondition(index, priceIndex) {
         this.sendDataInfo.specialList[index].priceConditions.splice(priceIndex, 1);
      },

      // 添加折扣条件
      addDiscountCondition(index) {
         if (!this.sendDataInfo.specialList[index].discountConditions) {
            this.$set(this.sendDataInfo.specialList[index], 'discountConditions', []);
         }
         // 同时添加折扣和数量条件
         this.sendDataInfo.specialList[index].discountConditions.push({
            num: '',
            discount: ''
         });
      },

      getDiscountConditions(index) {
         return this.sendDataInfo.specialList[index].discountConditions || [];
      },

      removeDiscountCondition(index, discountIndex) {
         this.sendDataInfo.specialList[index].discountConditions.splice(discountIndex, 1);
      },
      // 验证折扣值
      validateDiscount(value, index, discountIndex) {
         if (value === '') {
            this.sendDataInfo.specialList[index].discountConditions[discountIndex].discount = '';
            return;
         }

         let num = parseFloat(value);
         if (isNaN(num)) {
            num = 0;
         }

         // 限制在0-1之间
         num = Math.max(0, Math.min(1, num));
         // 保留两位小数
         num = Math.round(num * 100) / 100;

         this.sendDataInfo.specialList[index].discountConditions[discountIndex].discount = num;
      },

      // 打开促销周期和日期选择弹窗
      openPromotionDialog() {
         console.log('openPromotionDialog 被调用');
         this.tempWeekDays = [...(this.sendDataInfo.mzWeekDays || [])];
         this.tempMonthDays = [...(this.sendDataInfo.mzMonthDays || [])];
         this.promotionDialogVisible = true;
         console.log('弹窗状态:', this.promotionDialogVisible);

         // 强制设置z-index
         this.$nextTick(() => {
            const dialogEl = document.querySelector('.promotion-dialog .el-dialog');
            if (dialogEl) {
               dialogEl.style.zIndex = '9999';
            }
         });
      },

      // 确认选择促销周期和日期
      confirmPromotionSelection() {
         this.sendDataInfo.mzWeekDays = [...this.tempWeekDays];
         this.sendDataInfo.mzMonthDays = [...this.tempMonthDays];
         this.promotionDialogVisible = false;
      },

      // 取消选择
      cancelPromotionSelection() {
         this.promotionDialogVisible = false;
      },

      // 全选促销周期
      selectAllWeekDays() {
         this.tempWeekDays = this.mzWeekDays.map(item => item.value);
      },

      // 不全选促销周期
      clearAllWeekDays() {
         this.tempWeekDays = [];
      },

      // 全选促销日期
      selectAllMonthDays() {
         this.tempMonthDays = this.mzMonthDays.map(item => item.value);
      },

      // 不全选促销日期
      clearAllMonthDays() {
         this.tempMonthDays = [];
      },

         // 方案选择相关方法
         openSchemeDialog() {
         console.log('openSchemeDialog 被调用', this.schemeDialogVisible);
         
         // 直接设置为 true
         this.schemeDialogVisible = true;
         this.selectedSchemeIndex = 0;
         
         // 添加调试信息
         console.log('设置后的状态:', this.schemeDialogVisible);
         
         // 检查弹窗元素是否存在
         this.$nextTick(() => {
            const dialogElement = document.querySelector('.promotion-dialog');
            console.log('弹窗元素:', dialogElement);
            
            const allDialogs = document.querySelectorAll('.el-dialog');
            console.log('所有弹窗元素:', allDialogs.length);
            
            this.getSchemeList();
         });
      },


      // 获取方案列表
      async getSchemeList() {
         try {
            // 这里需要根据实际的API接口来获取方案列表
            // 暂时使用模拟数据
            let responseData = await this.$http.getPlanListHistory(
               {
                  businessId: "",
                  creater: 0,
                  end: '',
                  ormId: 0,
                  page: 1,
                  planName: this.schemeSearchForm.planName,
                  planType: "",
                  reviewerCondition: "",
                  rows: 10,
                  start: '',
                  showType: 12
               }
            )
            if (responseData.status == 200) {
               this.schemeList = responseData.result.list
               this.schemeTotal = responseData.result.total
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               })
            }


         } catch (error) {
            console.error('获取方案列表失败:', error);
            this.$message.error('获取方案列表失败');
         }
      },

      // 搜索方案
      searchSchemes() {
         this.schemeCurrentPage = 1;
         this.getSchemeList();
      },

      // 重置搜索
      resetSchemeSearch() {
         this.schemeSearchForm = {
            planName: '',
            planType: ''
         };
         this.searchSchemes();
      },

      // 处理方案行点击
      handleSchemeRowClick(row, column, event) {
         const index = this.schemeList.findIndex(item => item.id === row.id);
         this.selectedSchemeIndex = index;
      },

      // 处理分页大小变化
      handleSchemeSizeChange(val) {
         this.schemePageSize = val;
         this.getSchemeList();
      },

      // 处理当前页变化
      handleSchemeCurrentChange(val) {
         this.schemeCurrentPage = val;
         this.getSchemeList();
      },

      // 应用选中的方案
      applySelectedScheme() {
         if (this.selectedSchemeIndex === null || this.selectedSchemeIndex < 0) {
            this.$message.warning('请选择一个方案');
            return;
         }

         const selectedScheme = this.schemeList[this.selectedSchemeIndex];
         if (!selectedScheme) {
            this.$message.warning('选中的方案不存在');
            return;
         }

         // 覆盖当前页面数据
         this.applySchemeData(selectedScheme);
         this.schemeDialogVisible = false;
         this.$message.success('方案应用成功');
      },

      // 应用方案数据到当前页面
      async applySchemeData(scheme) {
         console.log(scheme, 'scheme');
         // 获取商品详情内容
         let responseData = await this.$http.getPlanDetail({
            ids: [scheme.planId]
         })
         if (responseData.status == 200) {
            this.actionData.oldData = responseData.result
             // 回显数据
            this.checkDisabled = this.actionData?.checkDisabled ? true : false

            if (this.actionData.oldData) {
               for (let key in this.actionData.oldData) {
                  // 特殊处理周期类型
                  if (key === "roundWeek") {
                     const roundWeek = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzWeekDays = roundWeek;
                  } else if (key === "roundDay") {
                     const roundDay = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzMonthDays = roundDay;
                  } else if (key === "dayStartTime" || key === "dayEndTime") {
                     // 特殊处理每日时间字段，将秒数转换为时间字符串
                     const seconds = this.actionData.oldData[key];
                     if (seconds !== null && seconds !== undefined && seconds !== "") {
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                        this.$set(this.sendDataInfo, key, timeString);
                     } else {
                        this.$set(this.sendDataInfo, key, "");
                     }
                  } else {
                     this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                  }
               }


               // 参与商品列表
               if (this.actionData.oldData.clList && this.actionData.oldData.clList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.clList.map(item =>
                     this.convertToSpecialListItem(item, false)
                  );
                  console.log('回显商品列表:', this.sendDataInfo.specialList);
               }



               // 回显会员卡类型和门店选择
               this.$nextTick(async () => {
                  // 回显会员卡类型选择
                  if (this.actionData.oldData.mcTypeList && this.actionData.oldData.mcTypeList.length > 0) {
                     await this.loadCardTypeData();
                     // 获取所有需要选中的卡类型ID
                     const selectedIds = this.actionData.oldData.mcTypeList.map(item => item.capId);
                     // 设置选中状态
                     this.selectedCardTypeIds = selectedIds;
                     this.sendDataInfo.selectedCardTypeIds = selectedIds;
                     // 设置选中的对象数组
                     this.selectedCardTypes = this.cardTypeList.filter(item => selectedIds.includes(item.capId));
                     console.log('已选中会员卡类型:', this.selectedCardTypes.length);
                     
                     // 设置表格选中状态
                     this.$nextTick(() => {
                        if (this.$refs.cardTypeTable) {
                           this.selectedCardTypes.forEach(cardType => {
                              this.$refs.cardTypeTable.toggleRowSelection(cardType, true);
                           });
                        }
                     });
                  }



                  // 回显门店选择
                  if (this.actionData.oldData.storeList && this.actionData.oldData.storeList.length > 0) {
                     await this.loadStoreData();
                     const selectedStoreIds = this.actionData.oldData.storeList;
                     console.log(this.storeList, 'this.storeList');

                     // 使用 nextTick 确保 DOM 已更新
                     await this.$nextTick();
                     // 确保 storeTable 存在
                     if (this.$refs.storeTable) {
                        this.storeList.forEach(item => {
                           const itemId = item.id || item.storeId;
                           // 检查是否存在匹配的门店ID
                           const isSelected = selectedStoreIds.some(store =>
                              (store.id === itemId || store.storeId === itemId)
                           );
                           if (isSelected) {
                              this.$refs.storeTable.toggleRowSelection(item, true);
                           }
                        });
                     }
                  }
               })
            }
         }


      },
      // 将外部数据转换为 specialList 格式（用于回显和导入）
      convertToSpecialListItem(item, isFromImport = false) {
         const baseItem = {
            bgmId: item.bgmId || '',
            bgmName: item.bgmName || '',
            bgmCode: item.bgmCode || '',
            bgmSpec: item.bgmSpec || item.spec || '',
            spec: item.spec || '',
            manufacturer: item.manufacturer || '',
            barcode: item.barcode || '',
            placeorigin: item.placeorigin || '',
            retailPrice: item.retailPrice || 0,
            maxPsprice: item.maxPsprice || 0,
            salesPrice: item.salesPrice || 0,
            memberPrice: item.memberPrice || 0,
            isMem: 0,
            totalNum: 0,
            numPerOrder: 0,
            price: item.price || 0,
            memPrice: 0,
            dayPerOrder: '',
            pointMultiply: 1,
            isDiscount: 0,
            clType: item.clType || 1,
            num: item.num || '',
            discount: item.discount || '',
            priceConditions: [],
            discountConditions: []
         };

         if (isFromImport) {
            baseItem.priceConditions.push({
               num: item.num || '',
               price: item.price || ''
            });
            baseItem.discountConditions.push({
               num: item.num || '',
               discount: item.discount || ''
            });
         } else {
            if (item.clRuleList && item.clRuleList.length > 0) {
               const sortedRules = [...item.clRuleList].sort((a, b) => Number(a.sort) - Number(b.sort));
               sortedRules.forEach(rule => {
                  if (baseItem.clType === 1) {
                     baseItem.priceConditions.push({
                        num: rule.num,
                        price: rule.money
                     });
                  } else if (baseItem.clType === 2) {
                     baseItem.discountConditions.push({
                        num: rule.num,
                        discount: rule.rate
                     });
                  }
               });
            }
            if (baseItem.clType === 1) {
               if (baseItem.priceConditions.length === 0) {
                  baseItem.priceConditions.push({ num: '', price: '' });
               }
               baseItem.discountConditions.push({ num: '', discount: '' });
            } else if (baseItem.clType === 2) {
               if (baseItem.discountConditions.length === 0) {
                  baseItem.discountConditions.push({ num: '', discount: '' });
               }
               baseItem.priceConditions.push({ num: '', price: '' });
            }
         }

         return baseItem;
      },
      // 导入EXCEL相关方法
      closeExcel(val) {
         this.UploadVisible = false
         if (val && val.list && val.list.length > 0) {
            let addedCount = 0
            val.list.forEach(item => {
               const exists = this.sendDataInfo.specialList.some(
                  existingItem => existingItem.bgmId === item.bgmId
               )
               if (!exists) {
                  this.sendDataInfo.specialList.push(this.convertToSpecialListItem(item, true))
                  addedCount++
               }
            })
            this.$message({
               message: `已添加 ${addedCount} 个商品到参与商品列表`,
               type: 'success'
            })
         }
      },
      // 监听子组件导入EXCEL成功
      fileSuccess(val) {
         console.log('fileSuccess', JSON.parse(JSON.stringify(val)));
      },
      // 导入EXCEL
      handleExcel() {
         this.UploadVisible = true;
      },
   },

   mounted() {
      this.openBox()
   },

   beforeDestroy() {
   },
}
</script>
<style scoped>
:deep(.v_tabs_bottom) {
   background-color: #f0f1f4 !important;
}

.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   margin-top: 20px;
   border-top: 1px solid #eee;

}

#smManrange {
   width: 100%;
   display: flex;
   padding-left: 83px;
   margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
   width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
   width: 76% !important;
   margin-right: 20px;
   font-size: 12px;
}

.cmContent {
   padding-left: 10px;
   width: 90%;
}

.ellipsis-cell {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
   width: 100%;
}

/* 表格滚动样式 */
::v-deep .el-table {
   overflow-y: auto;
}

::v-deep .el-table__body-wrapper {
   overflow-y: auto;
   height: 100%;
}


/* 新的促销设置布局样式 */
.main-layout {
   min-height: 100vh;
   position: relative;
}

.left-section {
   width: calc(100% - 450px);
   /* 减去右侧区域宽度(300px)和间距(40px) */
   display: flex;
   flex-direction: column;
   min-width: 0;
   padding-bottom: 60px;
   /* 为底部按钮留出空间 */
   padding-right: 20px;
   /* 为右侧区域留出间距 */
   box-sizing: border-box;
   /* 确保padding包含在宽度内 */
   max-width: calc(100% - 450px);
   /* 确保不超过最大宽度 */
   overflow-x: hidden;
   /* 防止水平溢出 */
}

.right-section {
   width: 30%;

   min-width: 450px;
   width: 300px;
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
   display: flex;
   flex-direction: column;
   overflow: hidden;
   /* 减去顶部和底部的空间 */
   position: fixed;
   /* 固定定位 */
   top: 13px;
   /* 距离顶部20px */
   right: 20px;
   /* 距离右侧20px */
   z-index: 1001;
   /* 确保在左侧内容之上 */
}

.right-content {
   padding: 15px;
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow-y: auto;
   height: 100%;
   /* 确保内容区域占满高度 */
}


.right-content h3 {
   margin: 0 0 15px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   border-bottom: 2px solid #409eff;
   padding-bottom: 10px;
}

.right-content p {
   margin: 0;
   color: #606266;
   font-size: 14px;
   line-height: 1.5;
}


.right-content::-webkit-scrollbar {
   width: 4px;
}

.right-content::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.form-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
   /* 防止被压缩 */
}

.promotion-container {
   display: flex;
   flex: 1;
   min-height: 0;
   overflow: visible;
   margin-bottom: 20px;
}

.promotion-section {
   margin-top: 10px;
   width: 100%;
   /* background: #fff; */
   /* border: 1px solid #e4e7ed; */
   /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */
   display: flex;
   flex-direction: column;
   overflow: hidden;
}

.condition-section {
   width: 100%;
}

.section-header {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
   color: white;
   padding: 20px 25px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
}



.header-left h3 {
   margin: 0 0 5px 0;
   font-size: 18px;
   font-weight: 600;
   display: flex;
   align-items: center;
}

.section-desc {
   margin: 0;
   font-size: 13px;
   opacity: 0.9;
   font-weight: 400;
}

.header-actions-box {
   display: flex;
   gap: 10px;
   box-sizing: border-box;
}


.section-content {
   display: flex;
   flex-direction: column;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
   min-height: 0;
}

/* 类型选择器样式 */
.type-selector {
   background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
   padding: 20px;
   border: 1px solid #e4e7ed;
   flex-shrink: 0;
}

/* 商品列表容器样式 */
.goods-list-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   /* overflow: hidden; */
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow: hidden;
   min-height: 0;
}

.list-header {
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
   flex-shrink: 0;
}

.list-title {
   font-size: 14px;
   font-weight: 600;
   color: #303133;
}

.list-count {
   font-size: 12px;
   color: #606266;
   padding: 4px 8px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 4px;
   border: 1px solid rgba(64, 158, 255, 0.2);
}

.goods-table-wrapper {
   padding: 0;
   flex: 1;
   overflow: visible;
   /* min-height: 400px; */

}

/* 阶梯阶梯设置样式 */
.step-scheme-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   flex: 1;
   display: flex;
   flex-direction: column;
   height: 100%;
   /* 确保占满父容器高度 */
   min-height: 400px;
   /* 设置最小高度 */
}

.scheme-layout {
   display: flex;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
}

.scheme-list {
   width: 22%;
   border-right: 1px solid #e4e7ed;
   display: flex;
   flex-direction: column;
   background: #fafafa;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-list .list-header {
   flex-shrink: 0;
   /* 防止头部被压缩 */
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
}

/* 右侧商品管理样式 */
.scheme-goods {
   width: 78%;
   display: flex;
   flex-direction: column;
   background: #fff;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-items {
   flex: 1;
   /* 占据剩余空间 */
   overflow-y: auto;
   /* 垂直滚动 */
   overflow-x: hidden;
   /* 隐藏水平滚动 */
   padding: 15px;
   height: 100%;
   /* 铺满100%高度 */
}

/* 自定义滚动条样式 */
.scheme-items::-webkit-scrollbar {
   width: 6px;
}

.scheme-items::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.scheme-item {
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 15px;
   margin-bottom: 10px;
   border: 2px solid #e4e7ed;
   border-radius: 8px;
   cursor: pointer;
   transition: all 0.3s ease;
   background: #fff;
   position: relative;
   /* overflow: hidden; */
}


.scheme-item:hover {
   border-color: #409eff;
   box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
   transform: translateY(-2px);
}



.scheme-item.active {
   border-color: #409eff;
   background: linear-gradient(135deg, #ecf5ff 0%, #f0f9ff 100%);
   box-shadow: 0 6px 20px rgba(64, 158, 255, 0.2);
   transform: translateY(-2px);
}


.scheme-info {
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 5px;
}

.scheme-title {
   font-weight: 600;
   color: #303133;
   font-size: 14px;
}

.scheme-desc {
   color: #909399;
   font-size: 12px;
   white-space: nowrap;
   /* overflow: hidden; */
   text-overflow: ellipsis;
}

.scheme-goods-count {
   color: #409eff;
   font-size: 11px;
   font-weight: 500;
   padding: 2px 6px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 3px;
   display: inline-block;
   width: fit-content;
}

.scheme-actions {
   opacity: 0;
   transition: opacity 0.3s ease;
}

.scheme-item:hover .scheme-actions,
.scheme-item.active .scheme-actions {
   opacity: 1;
}

.quick-actions {
   display: flex;
   flex-direction: column;
   gap: 10px;
}

.quick-actions .el-button {
   width: 100%;
   justify-content: center;
}

/* 右侧区域新样式 */
.card-type-section,
.store-section {
   margin-bottom: 16px;
   background: #fff;
   border: 1px solid #e8eaed;
   border-radius: 6px;
   overflow: hidden;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.card-type-section .section-header,
.store-section .section-header {
   background: #f8f9fa;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.header-content {
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 14px;
   font-weight: 500;
   color: #2c3e50;
}

.header-content i {
   font-size: 16px;
   color: #5a6c7d;
}

.selection-count {
   background: #e3f2fd;
   color: #1976d2;
   padding: 4px 8px;
   border-radius: 12px;
   font-size: 12px;
   font-weight: 500;
   min-width: 40px;
   text-align: center;
}

.table-container {
   padding: 0;
   background: #fff;
}

/* 卡片类型项目样式 */
.card-code-text {
   font-size: 12px;
   color: #5a6c7d;
   font-weight: 500;
   background: #f5f6fa;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.card-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.discount-text {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.no-discount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 门店项目样式 */
.store-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.store-type-text {
   font-size: 12px;
   color: #5a6c7d;
   background: #f0f2f5;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.store-phone-text {
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.store-address-text {
   font-size: 12px;
   color: #7f8c8d;
   line-height: 1.3;
   max-width: 140px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   display: block;
}

.store-area-text {
   font-size: 12px;
   color: #27ae60;
   background: #f0f9f4;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

/* 表格样式优化 */
::v-deep .el-table--mini {
   font-size: 12px;
   border: none;
}

::v-deep .el-table--mini .el-table__header th {
   background-color: #fafbfc;
   color: #5a6c7d;
   font-weight: 500;
   border-bottom: 1px solid #e8eaed;
   padding: 10px 0;
}

::v-deep .el-table--mini .el-table__body td {
   padding: 8px 0;
   border-bottom: 1px solid #f5f6fa;
}

::v-deep .el-table--mini .el-table__body tr:hover>td {
   background-color: #f8f9fa;
}

::v-deep .el-table--mini .el-table__body tr:last-child>td {
   border-bottom: none;
}

/* 优雅表格样式 */
.elegant-table {
   border: none;
}

.elegant-table .el-table__header-wrapper {
   border-bottom: 1px solid #e8eaed;
}

.elegant-table .el-table__body-wrapper {
   background: #fff;
}




:deep(.el-table thead) {
   height: 40px !important;
}



/* 会员选择区域样式 */
.member-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

.member-table {
   background: #fff;
}

.member-list {
   max-height: 200px;
   overflow-y: auto;
}

.member-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.member-item:hover {
   background: #f8f9fa;
}

.member-item:last-child {
   border-bottom: none;
}

.item-card {
   width: 120px;
   text-align: center;
   font-size: 12px;
   font-weight: 500;
   margin: 0 8px;
}

.item-type {
   width: 50px;
   text-align: center;
   font-size: 12px;
   margin: 0 8px;
}

.item-phone {
   width: 120px;
   text-align: center;
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.header-card {
   width: 120px;
   text-align: center;
}

.header-type {
   width: 100px;
   text-align: center;
}

.header-phone {
   width: 120px;
   text-align: center;
}

.selection-header {
   background: #f8f9fa;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e8eaed;
}

.selection-title {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.card-type-table {
   background: #fff;
}

.table-header {
   display: flex;
   align-items: center;
   background: #fafbfc;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   font-weight: 500;
   color: #5a6c7d;
   font-size: 13px;
}

.header-checkbox {
   display: flex;
   align-items: center;
}

.header-text {
   margin-left: 8px;
}

.header-code {
   width: 120px;
   text-align: center;
}

.header-name {
   flex: 1;
   text-align: center;
}

.header-discount {
   width: 100px;
   text-align: center;
}

.card-type-list {
   max-height: 200px;
   overflow-y: auto;
}

.card-type-list::-webkit-scrollbar {
   width: 4px;
}

.card-type-list::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.card-type-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.card-type-item:hover {
   background: #f8f9fa;
}

.card-type-item:last-child {
   border-bottom: none;
}

.item-checkbox {

   display: flex;
   align-items: center;
}

.item-code {
   width: 120px;
   text-align: center;
   font-size: 12px;

   font-weight: 500;

   margin: 0 8px;
}

.item-name {
   flex: 1;
   text-align: center;
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.item-discount {
   width: 100px;
   text-align: center;
}

.card-discount {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 4px 8px;
   border-radius: 3px;
}

.card-no-discount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 复选框样式优化 */
::v-deep .el-checkbox {
   width: 100%;
   margin-right: 0;
}

::v-deep .el-checkbox__label {
   width: 100%;
   padding-left: 8px;
}

.promotion-condition-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px 20px 0 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
}

.condition-title {
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   margin-bottom: 20px;
   border-bottom: 1px solid #ebeef5;
   padding-bottom: 10px;
}

.disabled-container {
   position: relative;
   opacity: 0.7;
   pointer-events: none;
}

.disabled-container::after {
   content: '';
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background: rgba(255, 255, 255, 0.4);
   z-index: 10;
}

.disabled-notice {
   display: flex;
   align-items: center;
}

.disabled-notice .el-tag {
   margin-right: 10px;
}

/* 简约版头部样式 */
.section-header-simple {
   background: #f5f7fa;
   color: #333;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
   border-bottom: 1px solid #e4e7ed;
}

.header-left-simple h3 {
   margin: 0 0 5px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
}

.section-desc-simple {
   margin: 0;
   font-size: 12px;
   color: #606266;
   font-weight: 400;
}

.header-actions-simple {
   /* margin-top: 10px; */
   display: flex;
   gap: 10px;
}

#mzMonthDays {
   display: flex;
}

:deep(#mzMonthDays .el-form-item__content) {
   width: 80% !important;
}

/* 价格和折扣输入样式 */
.price-item,
.discount-item {
   display: flex;
   align-items: center;
   margin-bottom: 5px;
}

.price-item:last-child,
.discount-item:last-child {
   margin-bottom: 0;
}

.price-input,
.discount-input {
   width: 80px;
}

.add-price-btn,
.add-discount-btn,
.remove-price-btn,
.remove-discount-btn {
   padding: 0;
   margin-left: 5px;
}

.add-price-btn i,
.add-discount-btn i {
   color: #409EFF;
   font-size: 16px;
}

.remove-price-btn i,
.remove-discount-btn i {
   color: #F56C6C;
   font-size: 16px;
}

.price-condition-item,
.discount-condition-item {
   display: flex;
   align-items: center;
   margin-bottom: 8px;
}

.price-condition-item:last-child,
.discount-condition-item:last-child {
   margin-bottom: 0;
}

.price-input-group,
.discount-input-group {
   display: flex;
   align-items: center;
   width: 100%;
}

.num-input,
.price-input,
.discount-input {
   width: 100%;
}

.condition-actions {
   display: flex;
   gap: 5px;
   margin-left: 5px;
   white-space: nowrap;
}

.add-condition-btn,
.remove-condition-btn {
   padding: 0;
   margin-left: 5px;
}

.add-condition-btn i {
   color: #409EFF;
   font-size: 16px;
}

.remove-condition-btn i {
   color: #F56C6C;
   font-size: 16px;
}

.section-title {
   padding: 16px 20px;
   background: #f5f7fa;
   border-bottom: 1px solid #e4e7ed;
}

.title-text {
   font-size: 16px;
   font-weight: bold;
   color: #303133;
   position: relative;
   padding-left: 12px;
   display: flex;
   align-items: center;
}

.title-text::before {
   content: '';
   position: absolute;
   left: 0;
   top: 50%;
   transform: translateY(-50%);
   width: 4px;
   height: 16px;
   background: #409EFF;
   border-radius: 2px;
}

/* 表单分组样式 - 与cxAdjustmentActionII.vue保持一致 */
.form-group {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   margin-bottom: 10px;
   overflow: hidden;
}

.group-title {
   background: #f8f9fa;
   padding: 12px 20px;
   font-size: 14px;
   font-weight: 600;
   color: #495057;
   border-bottom: 1px solid #e4e7ed;
   margin: 0;
   display: flex;
   justify-content: space-between;
}

.form-row {
   display: flex;
   gap: 20px;
   padding: 20px;
   align-items: flex-start;
}

.form-row:not(:last-child) {
   border-bottom: 1px solid #f5f5f5;
}

.form-item-half {
   flex: 1;
   margin-bottom: 0 !important;
}

.form-item-full {
   width: 100%;
   margin-bottom: 0 !important;
}

/* 表单项标签样式 */
::v-deep .promotion-form .el-form-item__label {
   font-weight: 500;
   color: #606266;
   padding-right: 12px;
}

/* 输入框样式统一 */
::v-deep .promotion-form .el-input__inner,
::v-deep .promotion-form .el-textarea__inner,
::v-deep .promotion-form .el-select .el-input__inner,
::v-deep .promotion-form .el-date-editor .el-input__inner {
   border-radius: 6px;
   border: 1px solid #dcdfe6;
   transition: all 0.3s ease;
}

::v-deep .promotion-form .el-input__inner:focus,
::v-deep .promotion-form .el-textarea__inner:focus,
::v-deep .promotion-form .el-select .el-input__inner:focus,
::v-deep .promotion-form .el-date-editor .el-input__inner:focus {
   border-color: #409eff;
   box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 折扣输入框样式 */
:deep(.el-input-number.discount-input) {
   width: 120px;
}

:deep(.el-input-number.discount-input .el-input__inner) {
   padding-right: 25px;
   text-align: left;
}

:deep(.el-input-number.discount-input .el-input-number__decrease),
:deep(.el-input-number.discount-input .el-input-number__increase) {
   width: 20px;
}

/* 促销周期和日期选择弹窗样式 - 与cxAdjustmentActionII.vue保持一致 */
.promotion-selection-container {
   padding: 20px;
}

.selection-section {
   margin-bottom: 30px;
}

.selection-section:last-child {
   margin-bottom: 0;
}

.section-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 15px;
   padding: 12px 16px;
   background: #f8f9fa;
   border-radius: 6px;
   border: 1px solid #e9ecef;
}

.section-header h4 {
   margin: 0;
   font-size: 16px;
   font-weight: 600;
   color: #495057;
}

.selection-actions {
   display: flex;
   gap: 8px;
}

.checkbox-group {
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
}

.checkbox-group .el-checkbox-group {
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   width: 100%;
}

.checkbox-group .el-checkbox-button {
   margin-right: 0;
   margin-bottom: 8px;
}

/* 美化复选框按钮 */
::v-deep .el-checkbox-button__inner {
   border-radius: 6px;
   padding: 8px 16px;
   font-size: 14px;
   transition: all 0.3s ease;
}

::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
   background-color: #409eff;
   border-color: #409eff;
   color: #fff;
   box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

::v-deep .el-checkbox-button:not(.is-checked) .el-checkbox-button__inner:hover {
   background-color: #ecf5ff;
   border-color: #b3d8ff;
   color: #409eff;
}

/* 弹窗底部按钮样式 */
.dialog-footer .el-button {
   padding: 10px 20px;
   font-size: 14px;
   border-radius: 6px;
}

.dialog-footer .el-button--primary {
   background: linear-gradient(135deg, #409eff 0%, #1890ff 100%);
   border: none;
   box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.dialog-footer .el-button--primary:hover {
   background: linear-gradient(135deg, #66b1ff 0%, #40a9ff 100%);
   box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

/* 促销输入框样式 */
.promotion-input {
   cursor: pointer !important;
}

/* 会员卡类型选择区域样式 */
.card-type-selection {
   border: 1px solid #e8eaed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}


.selection-title {
   font-size: 13px;
   color: #606266;
   font-weight: 500;
}



.table-header {
   display: flex;
   background: #f5f7fa;
   border-bottom: 1px solid #e8eaed;
   font-weight: 600;
   font-size: 12px;
   color: #909399;
}

.header-checkbox {
   width: 50px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 8px;
   border-right: 1px solid #e8eaed;
}

.card-type-item {
   display: flex;
   border-bottom: 1px solid #f0f0f0;
   cursor: pointer;
   transition: background-color 0.2s ease;
}

.card-type-item:hover {
   background: #f8f9fa;
}

.card-type-item:last-child {
   border-bottom: none;
}

.item-checkbox {
   width: 50px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 8px;
   border-right: 1px solid #f0f0f0;
}

.item-name {
   flex: 1;
   padding: 8px 12px;
   border-right: 1px solid #f0f0f0;
   font-size: 13px;
   color: #303133;
   font-weight: 500;
}

.item-mzDiscount {
   width: 80px;
   padding: 8px 12px;
   text-align: center;
}

/* .card-mzDiscount {
   background: #fff2f0;
   color: #e74c3c;
   padding: 2px 6px;
   border-radius: 3px;
   font-size: 11px;
   font-weight: 500;
} */

.card-no-mzDiscount {
   color: #909399;
   font-size: 11px;
}

/* 响应式布局 */
@media (max-width: 1200px) {
   .form-row {
      flex-direction: column;
      gap: 16px;
   }

   .form-item-half {
      width: 100%;
   }
}
</style>